import {
    orgPerformanceLeafCategoryId,
    orgPerformanceLeafCategoryName,
    orgPerformanceMarketplace,
    orgPerformanceProductId,
    orgPerformanceProductSmallImageUrl,
    orgPerformanceProductTitle,
} from '../fieldCreators/orgPerformance'

export const ORG_PERFORMANCE_SPECIAL_GROUP_BY_COLUMNS = [
    orgPerformanceProductTitle(),
    orgPerformanceProductSmallImageUrl(),
    orgPerformanceProductId(),
    orgPerformanceLeafCategoryName(),
    orgPerformanceLeafCategoryId(),
    orgPerformanceMarketplace(),
]
